import http from "api/https";

// submitAfterSign — автопосылка после подписи (финальный шаг степпера, «Подписать и отправить
// в БГА»): заявка уходит на рассмотрение тем же запросом. Ответ — { autoSubmitted, submitErrorCode,
// submitErrorMessage }: сбой автопосылки не ломает успех подписи.
// languageCode — язык шаблона договора для автопосылки (ru/ky): выбор языка в кабинете,
// не локаль браузера.
export const signFiles = (
  ids: number[],
  applicationId: number,
  pin: string,
  code: string,
  pinOrganization?: string,
  submitAfterSign?: boolean,
  languageCode?: string
): Promise<any> => {
  return http.post(`/api/v1/appFile/SignDocuments`, {
    ids,
    applicationId,
    pin,
    code,
    ...(pinOrganization ? { pinOrganization } : {}),
    ...(submitAfterSign ? { submitAfterSign: true } : {}),
    ...(languageCode ? { languageCode } : {}),
  });
};

export const sendCode = (pin: string, pinOrganization?: string): Promise<any> => {
  const query = pinOrganization
    ? `pin=${pin}&pinOrganization=${pinOrganization}`
    : `pin=${pin}`;
  return http.get(`/api/v1/appFile/SendCode?${query}`, {});
};